import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import { PageBuilderBarcodeModel } from '../page-builder-barcode.model';

@Component({
    selector: 'abw-page-builder-barcode-design',
    templateUrl: './page-builder-barcode-design.component.html',
    styleUrls: ['./page-builder-barcode-design.component.scss']
})
export class PageBuilderBarcodeDesignComponent {
    @Input() model: PageBuilderBarcodeModel;
    @Input() value: string;
}